<template>
  <div class="Exporthk1">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn
          type="button"
          @click="
            exportexcelhk1(
              tokenexport,
              exportthn,
              exportbln,
              exportps,
              paparnegeriexport
            )
          "
          color="blue white white--text"
        >
          <span class="material-icons">file_download</span>
          {{ $t("muatturun") }} {{ $t("hk1") }}
        </v-btn> -->
            <download-excel
              :data = "papardatahk1"
              type="csv"
              name="hk1.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("hk1") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatahk1"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exporthk1",
  setup() {},
  props: [
    "papardatahk1",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      { text: "Bil", value: "Bil"},
      { text: "HID", value: "HID"},
      { text: "BNO", value: "BNO"},
      { text: "Pusingan", value: "Pusingan"},
      { text: "S", value: "S"},
      { text: "NG", value: "NG"},
      { text: "DP", value: "DP"},
      { text: "DB", value: "DB"},
      { text: "BP", value: "BP"},
      { text: "ST", value: "ST"},
      { text: "NOTK", value: "NOTK"},
      { text: "NOIR", value: "NOIR"},
      { text: "NOAIR", value: "NOAIR"},
      { text: "P", value: "P"},
      //{ text: "KAW", value: "KAW"},
      { text: "Bulan", value: "Bulan"},
      { text: "Tahun", value: "Tahun"},
      // { text: "BPK", value: "BPK"},
      // { text: "IDBPK", value: "IDBPK"},
      { text: "HK1PK", value: "HK1PK"},
      { text: "HK1PN", value: "HK1PN"},
      //{ text: "HK1Tp", value: "HK1Tp"},
      { text: "INCS11", value: "INCS11"},
      { text: "INCS11B", value: "INCS11B"},
      { text: "INCS12", value: "INCS12"},
      { text: "INCS12B", value: "INCS12B"},
      { text: "INCS13", value: "INCS13"},
      { text: "INCS13B", value: "INCS13B"},
      { text: "INCS14", value: "INCS14"},
      { text: "INCS14B", value: "INCS14B"},
      { text: "INCS15", value: "INCS15"},
      { text: "INCS15B", value: "INCS15B"},
      { text: "INCS16", value: "INCS16"},
      { text: "INCS16B", value: "INCS16B"},
      { text: "INCS17", value: "INCS17"},
      { text: "INCS17B", value: "INCS17B"},
      { text: "INCS18", value: "INCS18"},
      { text: "INCS18B", value: "INCS18B"},
      { text: "INCS19a", value: "INCS19a"},
      { text: "INCS19aB", value: "INCS19aB"},
      { text: "INCS19b", value: "INCS19b"},
      { text: "INCS19bB", value: "INCS19bB"},
      { text: "INCS19c", value: "INCS19c"},
      { text: "INCS19cB", value: "INCS19cB"},
      { text: "INCS19", value: "INCS19"},
      { text: "INCS01", value: "INCS01"},
      // { text: "PENHK1", value: "PENHK1"},
      // { text: "dateMula", value: "dateMula"},
      // { text: "dateTamat", value: "dateTamat"},
      { text: "M", value: "M"},
      { text: "HK1KL", value: "HK1KL"},
    ],
  }),
  methods: {
    async exportexcelhk1(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/HK/exporthk1serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>